import { Component, EventEmitter, Input, Output } from '@angular/core'
@Component({
  selector: 'app-action-toolbar',
  imports: [],
  templateUrl: './action-toolbar.component.html',
  styleUrl: './action-toolbar.component.scss',
  standalone: false,
})
export class ActionToolbarComponent {
  @Input() isEdit: boolean
  @Output() editClick = new EventEmitter<void>()
  @Input() isFullView: boolean
  @Output() fullViewClick = new EventEmitter<void>()
  @Input() isHistory: boolean
  @Output() historyClick = new EventEmitter<void>()
  @Input() isReport: boolean
  @Output() reportClick = new EventEmitter<void>()
  @Input() isNew: boolean
  @Output() newClick = new EventEmitter<void>()

  onEditClick(): void {
    // Emit the event to notify the parent component (wrapper component)
    this.editClick.emit()
  }

  onFullViewClick(): void {
    // Emit the event to notify the parent component (wrapper component)
    this.fullViewClick.emit()
  }

  onHistoryClick(): void {
    // Emit the event to notify the parent component (wrapper component)
    this.historyClick.emit()
  }

  onReportClick(): void {
    // Emit the event to notify the parent component (wrapper component)
    this.reportClick.emit()
  }

  onNewClick(): void {
    // Emit the event to notify the parent component (wrapper component)
    this.newClick.emit()
  }
}
